import { Component, Input, OnInit, ViewChild, ElementRef } from "@angular/core";
import { BaseComponent, UserService, EventBusService } from "@mypxplat/xplat/core";
import { css, cx } from "styled-system/css";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "fui-footer",
  templateUrl: "footer.component.html",
  standalone: false,
})
export class FuiFooterComponent extends BaseComponent implements OnInit {
  public year: number = new Date().getFullYear();
  constructor(
    userService: UserService,
    public appService: AppService
  ) {
    super(userService);
  }

  ngOnInit(): void {}
}
